import React from 'react';
import { useAuth } from '../../context/AuthContext';

export default function MyProfile() {
  const { currentUser } = useAuth();
  
  // Mock data fitting the screenshot
  const mobile = "+918800770908";
  const company = "Coneberry Productions LLC";
  const country = "India";
  const city = "New Delhi";
  const address = "C-1, plot 4&5, 3rd floor, Near dwarka mor metro station";

  return (
    <div style={styles.container}>
      <h2 style={styles.pageTitle}>My Profile</h2>

      <div className="card" style={styles.profileCard}>
        <div style={styles.headerRow}>
          <div style={styles.userInfo}>
            <div style={styles.hugeAvatar}>
              {(currentUser?.displayName || 'M')[0].toUpperCase()}
            </div>
            <div>
              <h3 style={styles.name}>{currentUser?.displayName || 'Manish Roshan'}</h3>
              <div style={styles.emailRow}>
                <span style={styles.email}>{currentUser?.email || 'manish@coneberry.com'}</span>
                <span style={styles.verifiedBadge}>Email Verified</span>
              </div>
            </div>
          </div>
          <button className="btn btn-primary">Edit Profile</button>
        </div>

        <table className="data-table" style={styles.table}>
          <tbody>
            <tr>
              <th style={styles.th}>Mobile</th>
              <td style={styles.td}>{mobile}</td>
            </tr>
            <tr>
              <th style={styles.th}>Company</th>
              <td style={styles.td}>{company}</td>
            </tr>
            <tr>
              <th style={styles.th}>Country</th>
              <td style={styles.td}>{country}</td>
            </tr>
            <tr>
              <th style={styles.th}>City</th>
              <td style={styles.td}>{city}</td>
            </tr>
            <tr>
              <th style={styles.th}>Address</th>
              <td style={styles.td}>{address}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

const styles = {
  container: {
    maxWidth: '1200px',
  },
  pageTitle: {
    marginBottom: '1.5rem',
    fontSize: '1.25rem',
    color: '#333',
  },
  profileCard: {
    padding: '2rem',
  },
  headerRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '2rem',
  },
  userInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: '1.5rem',
  },
  hugeAvatar: {
    width: 64,
    height: 64,
    borderRadius: '50%',
    background: '#f39c12',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 700,
    fontSize: '2rem',
    border: '4px solid #fff',
    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
  },
  name: {
    fontSize: '1.25rem',
    marginBottom: '0.25rem',
    color: '#111',
  },
  emailRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem',
  },
  email: {
    fontSize: '0.9rem',
    color: '#666',
  },
  verifiedBadge: {
    background: '#e0f2f1',
    color: '#00897b',
    padding: '0.15rem 0.5rem',
    borderRadius: '12px',
    fontSize: '0.7rem',
    fontWeight: 600,
  },
  table: {
    borderTop: '1px solid #e5e7eb',
    borderLeft: '1px solid #e5e7eb',
    borderRight: '1px solid #e5e7eb',
  },
  th: {
    width: '25%',
    background: '#fff',
    color: '#444',
    borderRight: '1px solid #e5e7eb',
  },
  td: {
    color: '#555',
  }
};
